export { landingPageFooterAdapter } from './adapters';

export { default as LandingPageFooter } from './LandingPageFooter';
